import { connect } from 'react-redux';
import SearchBukuDetail from '../../../views/Library/SearchBuku/SearchBukuDetail.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(SearchBukuDetail);
